var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    className: "user_profile_svg__Component-icon-0-1-19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6373A4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.981,
    cy: 6.948,
    r: 3.232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.961 0C4.026 0 0 4.006 0 8.961s4.026 8.962 8.961 8.962c4.936 0 8.962-4.026 8.962-8.962C17.923 4.026 13.897 0 8.96 0zm5.265 14.613c-.658-1.761-2.09-3.639-5.265-3.639-3.155 0-4.606 1.878-5.264 3.639-1.51-1.413-2.478-3.426-2.478-5.652 0-4.258 3.465-7.742 7.742-7.742a7.74 7.74 0 017.742 7.742c0 2.226-.968 4.239-2.477 5.652z"
  }))));
}

export default SvgUserProfile;